export const VIDEOS_API =
  "https://jnn-videos-preview.jason-nguyen395.workers.dev/videos/api";

export interface VideoItem {
  id: string;
  title: string;
  date: string;
  short: boolean;
  duration: string;
  category: string;
  thumbnail: string;
  embedUrl: string;
  url: string;
}

export interface VideoCategory {
  slug: string;
  name: string;
  description: string;
  comingSoon?: boolean;
  count: number;
}

export interface VideoCollection {
  slug: string;
  title: string;
  category: string;
  description: string;
  lessonCount: number;
  lessons: string[]; // video IDs
}

export interface VideosApiResponse {
  videos: VideoItem[];
}

export interface CatalogApiResponse {
  categories: VideoCategory[];
  collections: VideoCollection[];
}

export interface HistoryItem {
  id: string;
  t: string; // title
  href: string;
  ts: number; // timestamp
}

export const getHistory = (): HistoryItem[] => {
  try {
    const raw = localStorage.getItem("jnn-videos-history");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
  } catch {
    // fallback
  }
  return [];
};

export const saveToHistory = (item: {
  id: string;
  t: string;
  href: string;
}) => {
  try {
    const history = getHistory().filter((h) => h.id !== item.id);
    const updated = [{ ...item, ts: Date.now() }, ...history].slice(0, 50);
    localStorage.setItem("jnn-videos-history", JSON.stringify(updated));
    window.dispatchEvent(new Event("jnn-videos-history-updated"));
  } catch {
    // ignore quota/storage issues
  }
};

export const clearHistory = () => {
  try {
    localStorage.removeItem("jnn-videos-history");
    window.dispatchEvent(new Event("jnn-videos-history-updated"));
  } catch {
    // ignore
  }
};
